import * as Yup from "yup";

const SignupSchema = Yup.object().shape({
  firstname: Yup.string().required("First Name is Required"),
  middlename: Yup.string().required("Middle Name is Required"),
  lastname: Yup.string().required("Last Name is Required"),
  sex: Yup.string().required("Sex is Required"),
  phonenumber: Yup.string()
    .matches(/^\d{9}$/, "Phone number must be 9 digits")
    .required("Phone Number is Required"),
  email: Yup.string().email().required("Email is Required"),
  position: Yup.string(),
  facility: Yup.string(),
  isAdmin: Yup.boolean(),
  password: Yup.string()
    .min(6, "Min of 6 digits.")
    .required("Password is Required"),
  adminDocument: Yup.string(),
});

export const signupFormik = {
  validateOnChange: false,
  validateOnBlur: false,
  initialValues: {
    firstname: "",
    middlename: "",
    lastname: "",
    sex: "",
    phonenumber: "",
    email: "",
    facility: "0",
    position: "",
    password: "",
    isAdmin: false,
    adminDocument: "",
  },
  validationSchema: SignupSchema,
};

const UserSchema = Yup.object().shape({
  firstname: Yup.string().required("First Name is Required"),
  middlename: Yup.string().required("Middle Name is Required"),
  lastname: Yup.string().required("Last Name is Required"),
  role: Yup.number().required("Role is Required"),
  phonenumber: Yup.string()
    .matches(/^\d{9}$/, "Phone number must be 9 digits")
    .required("Phone Number is Required"),
  email: Yup.string().email().required("Email is Required"),
  password: Yup.string()
    .min(6, "Min of 6 digits.")
    .required("Password is Required"),
});

export const createUserFormik = {
  validateOnChange: false,
  validateOnBlur: false,
  initialValues: {
    firstname: "",
    middlename: "",
    lastname: "",
    role: 0,
    phonenumber: "",
    email: "",
    password: "",
  },
  validationSchema: UserSchema,
};

